"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDuoJobPending = exports.FINISHED_JOB_STATI = exports.DatevOnlineJobStatusEnum = void 0;
var DatevOnlineJobStatusEnum;
(function (DatevOnlineJobStatusEnum) {
    DatevOnlineJobStatusEnum["PROCESSING"] = "processing";
    DatevOnlineJobStatusEnum["FINISHED"] = "finished";
    DatevOnlineJobStatusEnum["PARTIALLY_FINISHED"] = "partially_finished";
    DatevOnlineJobStatusEnum["ERROR"] = "error";
    DatevOnlineJobStatusEnum["RECEIVED"] = "received";
})(DatevOnlineJobStatusEnum || (exports.DatevOnlineJobStatusEnum = DatevOnlineJobStatusEnum = {}));
exports.FINISHED_JOB_STATI = [DatevOnlineJobStatusEnum.FINISHED, DatevOnlineJobStatusEnum.ERROR];
const isDuoJobPending = (status) => status === DatevOnlineJobStatusEnum.PROCESSING || status === DatevOnlineJobStatusEnum.RECEIVED;
exports.isDuoJobPending = isDuoJobPending;
